import e from "react";
import { forwardRef as n, Button as o } from "@chakra-ui/react";
const c = [
  "transparent",
  "primary",
  "secondary",
  "tertiary",
  "accent",
  "onActionTertiary"
], l = ["xsmall", "small", "medium", "large"], s = n(
  ({ children: t, ...r }, a) => /* @__PURE__ */ e.createElement(o, { ref: a, ...r }, t)
);
s.displayName = "Button";
export {
  s as Button,
  l as sizes,
  c as variants
};
